import React, { useState } from 'react';
import { View, Text, TouchableOpacity, TextInput } from 'react-native';

import api from '../../services/api';
import isEmail from '../../utils/isValidEmail';

const CriarVendedor = ({ navigation }) => {
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');

  const cadastrarVendedor = () => {
    if (!nome.length) {
      return alert('Nome deve conter pelo menos 1 digito');
    }

    if (!isEmail(email)) {
      return alert('E-mail invalido.');
    }

    api
      .post('vendedores', {
        nome,
        email,
      })
      .then(() => {
        alert('Cadastro realizado com sucesso');
        navigation.goBack();
      })
      .catch((e) => {
        if (e.response.data.msg) {
          alert(e.response.data.msg);
        } else {
          alert(
            'Falha ao cadastrar o vendedor, por favor verifique todos os campos'
          );
        }
      });
  };

  return (
    <View style={{ flex: 1 }}>
      <View style={{ margin: 20, flex: 1 }}>
        <View
          style={{
            backgroundColor: '#fff',
            padding: 10,
            marginTop: 10,
            borderRadius: 5,
          }}
        >
          <Text style={{ fontSize: 12 }}>Nome do vendedor</Text>
          <TextInput
            onChangeText={setNome}
            value={nome}
            style={{
              paddingTop: 5,
              marginTop: 5,
              paddingBottom: 5,
              paddingLeft: 5,
              borderWidth: 1,
              borderColor: '#000',
              borderRadius: 5,
            }}
          />

          <Text style={{ fontSize: 12, marginTop: 10 }}>Email</Text>
          <TextInput
            onChangeText={(e) => setEmail(e.toLowerCase())}
            value={email}
            style={{
              paddingTop: 5,
              marginTop: 5,
              paddingBottom: 5,
              paddingLeft: 5,
              borderWidth: 1,
              borderColor: '#000',
              borderRadius: 5,
            }}
          />

          <Text style={{ fontSize: 12, marginTop: 10 }}>
            A senha padrao para novos usuarios é 123456
          </Text>
        </View>

        <View style={{ display: 'flex', flexDirection: 'row', marginTop: 25 }}>
          <TouchableOpacity
            onPress={() => cadastrarVendedor()}
            style={{ flex: 1, marginLeft: 5 }}
          >
            <Text
              style={{
                padding: 5,
                textAlign: 'center',
                backgroundColor: '#1abc9c',
                color: '#fff',
                borderRadius: 5,
              }}
            >
              Salvar
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

export default CriarVendedor;
